import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ThemeProvider() {
  const location = useLocation();

  useEffect(() => {
    // Set data-theme on <html> (default theme for home-1)
    document.documentElement.setAttribute("data-theme", "");

    // Optional cleanup on unmount
    return () => {
      document.documentElement.removeAttribute("data-theme");
    };
  }, [location.pathname]);

  return null;
}